// extracted by mini-css-extract-plugin
export default {"sideField":"inventoryInternal_sideField__MFa-C","span":"inventoryInternal_span__iwHOK","body":"inventoryInternal_body__-bWul"};